// extracted by mini-css-extract-plugin
export default {"validationErrorText":"FooterError-rebranding-module__validationErrorText___2X63c"};